import './styles/social.scss';
import React, {Component} from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import RequestManager from "../../requests/RequestManager";
import LogoutOttV1Task from '../../requests/tasks/user/v1/LogoutOttV1Task';
import { playFullMedia, playPipMedia } from '../../actions/playmedia';
import UtilsProfile from './../../utils/Profile';
import store from './../../store';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage'
import Utils, { showSpinner } from '../../utils/Utils';
import { isLoggedIn } from '../../requests/loader';
import hasHboSubscription from '../../utils/user/hasHboSubscription';
import { fetchHBOStatus, receiveIsLoggedIn } from '../../reducers/user';
import { GA4 } from '../../utils/trackers/GA4';
import { showModalActivaHBOMaxQR } from '../CardNew/utils';
import { QR_ACTIVATION_CONFIG_HBO_DEFAULT } from '../RibbonNew/constants';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import logger from 'src/utils/logger/logger';
import loadInitApis from '../../config/applicationLoader';
import { resetSession } from '../../reducers';
import appHistory from '../../utils/history';
import AAF from '../../AAF/AAF';
import LayersControl from '../../utils/LayersControl';
import { fetchLinealChannels } from '../../actions/payway';

export const IS_FROM_REFRESH_TOKEN = 'isFromRefreshToken'

let ps4LogoutInProgress = false;

const restartAnonymousSession = async (isFromRefreshToken, history) => {
  store.dispatch(playPipMedia({ src: null, event: null, playerstate: AAFPLAYER_STOP }));
  AAF.Database.setUserToken(null);
  store.dispatch(resetSession());
  AAF.AdsUtils.recibeProps(history);
  window.youboraUserId = null;
  showSpinner(true);

  try {
    await loadInitApis();
    const result = await isLoggedIn();
    const user = result && (result.response || result.data);
    if (user) {
      store.dispatch(receiveIsLoggedIn({ ...user, is_user_logged_in: 0 }));
    }
    await AAF.AdsUtils.loadUserType();
    await store.dispatch(fetchLinealChannels(user && user.user_id));
  } catch (error) {
    logger.error('[logout] Anonymous session initialization failed:', error);
    AAF.Database.setUserToken(null);
    DeviceStorage.unsetItem('user_token');
    DeviceStorage.unsetItem('user_hash');
    store.dispatch(resetSession());
    AAF.AdsUtils.recibeProps(history);
  } finally {
    history.replace(isFromRefreshToken ? '/login' : '/landing');
    showSpinner(false);
    LayersControl.showUX(true);
  }
};

export const doLogout = (isFromRefreshToken, history = appHistory)=>{
  const platform = Device.getDevice().getPlatform();
  if (platform === 'ps4' && ps4LogoutInProgress) {
    return Promise.resolve();
  }
  if (platform === 'ps4') {
    ps4LogoutInProgress = true;
  }
  const service =  new LogoutOttV1Task()

  const userPaymentMethods = store.getState() && store.getState().user && store.getState().user.paywayProfile && store.getState().user.paywayProfile.paymentMethods;

  const checkIpTelmexSession = (paymentMethods) => {
    if (!Array.isArray(paymentMethods)) return false;
    return paymentMethods.some(method => method && method.gateway === 'telmexmexicogate');
  };

  const isIpTelmexSession = checkIpTelmexSession(userPaymentMethods);

  if(isIpTelmexSession){
    DeviceStorage.setItem('from_logout', 'true');
  }
  
  return RequestManager.addRequest(service).then(async (resp) => {
    if (resp.response) {

      const ui = DeviceStorage.getItem('__UUID__');
      const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');
      store.dispatch(playFullMedia({ src: null,  event: null, playerstate: AAFPLAYER_STOP }));
      const ads = DeviceStorage.getItem('ADS_ENABLE')
      DeviceStorage.clear();

      const isAndroid = platform === 'android';
      try {
        if (isAndroid && window.AndroidPlayerInterface) {
          window.AndroidPlayerInterface.getUserInformation();
        }
      } catch (error) {
        logger.error('[ERROR]-error on getUserInformation', error);
      }

      DeviceStorage.setItem('__UUID__', ui);
      DeviceStorage.setItem('IsLogOut', true);
      if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');

      if (isIpTelmexSession) {
        DeviceStorage.setItem('from_logout', 'true');
        DeviceStorage.unsetItem('ip_telmex_session_start');
        DeviceStorage.unsetItem('is_ip_telmex_session');
      }

      Utils.cleanCustomAttribute();
      
      if (platform !== 'ps4') {
        isLoggedIn();
      }
    
      if (isFromRefreshToken) {
        DeviceStorage.setItem(IS_FROM_REFRESH_TOKEN, true)
        // AAF.AdsUtils.getProps().push(ads ? '/node/homeuser_lite' : '/landing')
        if (platform !== 'ps4') setTimeout(() => {
            window.location.href='/login'
        }, 300);
      }
      else if (platform !== 'ps4') {
        setTimeout(() => {
            window.location.href = '/';
        }, 300);
      }


      // Youbora
      if(window.youboraTrackingPlugin){
        if(window.youboraTrackingPlugin.storage){
          if(window.youboraTrackingPlugin.storage.removeLocal
            && typeof window.youboraTrackingPlugin.storage.removeLocal === "function"){
            window.youboraTrackingPlugin.storage.removeLocal('data');
          }
          if(window.youboraTrackingPlugin.storage.removeSession
            && typeof window.youboraTrackingPlugin.storage.removeSession === "function"){
            window.youboraTrackingPlugin.storage.removeSession('data');
          }
        }
        if(window.youboraTrackingPlugin.restartViewTransform
          && typeof window.youboraTrackingPlugin.restartViewTransform === "function"){
          window.youboraTrackingPlugin.restartViewTransform();
        }
        if(window.youboraTrackingPlugin.setOptions
          && typeof window.youboraTrackingPlugin.setOptions === "function"){
          window.youboraTrackingPlugin.setOptions();
        }
      }
      if(window.youboraAnalyticsPlugin
        && window.youboraAnalyticsPlugin.infinity
        && typeof window.youboraAnalyticsPlugin.infinity.fireSessionStop === "function"){
        window.youboraAnalyticsPlugin.infinity.fireSessionStop();
      }

      if (platform === 'ps4') {
        await restartAnonymousSession(isFromRefreshToken, history);
      }

    }
  }).catch((err) => {
    logger.error(err);
  }).then(() => {
    if (platform === 'ps4') {
      ps4LogoutInProgress = false;
    }
  });
};

class ModalProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttons: [],
    }
  }

  async componentDidMount() {
    const buttons = await this.getButtons();
    this.setState({ buttons });
    this.setFirstFocus();
  }

  setFirstFocus() {
    setTimeout(() => {
      window.SpatialNavigation.focus('.modal-social .focusable');
    }, 100);
  }

  async getButtons() {
    const { props } = this;
    const buttons = [];
    let enableAbout = false; // Valor por defecto en caso de no tenerlo definido desde propiedades
    if(typeof this.props.enableAbout !== 'undefined' && this.props.enableAbout !== null){
      enableAbout = this.props.enableAbout;
    }

    const profile = store.getState().profile;
    const user = store.getState().user;

    if (UtilsProfile.isProfileEnable(user)) {

      if (profile && profile.admin) {

        buttons.push({
          content: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
          props: {
            onClick: (e) => this.props.handleClose(e, this.props.callback('user-settings/idioma')),
            onMouseEnter: (e) => this.props.onMouseEnter(e),
          }
        });

        buttons.unshift({
          content: Translator.get('menu_manage_profiles_label', 'Administrar Perfiles'),
          props: {
            onClick: (e) => {
              this.props.handleClose(e, this.props.callback('profile/admin', false, null))
            },
            onMouseEnter: (e) => this.props.onMouseEnter(e),
          }
        });
      }

      profile.members && profile.members.forEach((member) => {

      buttons.push({
        content: member.username,
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback('profile', null, member))
          },
          onMouseEnter: (e) => props.onMouseEnter(e),
          imgSrc: UtilsProfile.changeProtocolURLImage(`${member.user_image}&impolicy=resize&vwidth=27`),
          imgClassName: 'avatar',
          imgId: member.gamification_id,
          imgAlt: ''
        }
      });
    });

    } else {
      buttons.push({
        content: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
        props: {
          onClick: (e) => this.props.handleClose(e, this.props.callback('user-settings/idioma')),
        }
      });
      if (props.enableSocialProfile) {
        buttons.unshift({
          content: Translator.get('social_profile_card_header', 'Mi Perfil'),
          props: {
            onClick: (e) => {
              this.props.handleClose(e, this.props.callback(`socialProfile/${this.props.gamificationId}`))
            },
            onMouseEnter: (e) => this.props.onMouseEnter(e),
          }
        });
      }
    }

    if (enableAbout) {
      buttons.push({
        content: Translator.get('about_card_header', 'Acerca de'),
        props: {
          onClick: (e) => {
            this.props.handleClose(e, this.props.callback('about'))
          },
          onMouseEnter: (e) => this.props.onMouseEnter(e),
        }
      });
    }

    if (props.enableSocialProfile && profile && profile.admin) {
      buttons.unshift({
        content: Translator.get('social_profile_card_header', 'Mi Perfil'),
        props: {
          onClick: (e) => {
            this.props.handleClose(e, this.props.callback(`socialProfile/${this.props.gamificationId}`))
          },
          onMouseEnter: (e) => this.props.onMouseEnter(e),
        }
      });
    }

    if (props.enableSessionRefresh) {
      buttons.unshift({
        content: Translator.get('btn_session_refresh', 'Refrescar sesión'),
        props: {
          onClick: (e) => {
            this.props.handleClose(e, this.props.callback(null, true))
          },
          onMouseEnter: (e) => this.props.onMouseEnter(e),
        }
      });
    }

    const hboSubscription = hasHboSubscription(store.getState());
    const hboMaxActivationLinkageEnabled = Utils.getRegionaliazedMetadata('wbd_hbo_max_activation_linkage_enabled').enabled;
    const statusHBO = store.getState().user && store.getState().user.statusHBO;

    const canUseHboActivation = user && user.admin && hboSubscription && hboMaxActivationLinkageEnabled;
    const shouldCheckHboLinkStatus = statusHBO == null || statusHBO !== 'linked' || statusHBO == undefined ;

    let isHboActivated = true

    if (canUseHboActivation && shouldCheckHboLinkStatus) {
      try{
        await store.dispatch(fetchHBOStatus());
        const statusHBO = store.getState().user && store.getState().user.statusHBO;
        isHboActivated = (statusHBO == null || statusHBO === 'linked');
      }catch(e){
        console.error('Error checking HBO link status:', e);
      }
    }

    if (canUseHboActivation && !isHboActivated) {
      buttons.push({
        content: Translator.get('activahbomax_menuavatar_nodo_hbomax_texto_activar'),
        props: {
          onClick: this.handleClickActivateHBO,
          onMouseEnter: (e) => this.props.onMouseEnter(e),
        }
      });
    }

    const LogOutButton = Utils.getApaMetadataKey('is_logout_visible', '{false}');

    if(LogOutButton) {
      buttons.push({
        content: Translator.get('social_close_session', 'Cerrar Sesion'),
        props: {
          onClick: () => doLogout(false, this.props.history || appHistory),
          onMouseEnter: (e) => props.onMouseEnter(e),
        }
      });
    }
    return buttons;
  }

  handleClickActivateHBO = async () => {
    this.sendMetricsActivateHBO();
    const qrActivationConfigHBO = Utils.getRegionaliazedMetadata('qr_activation_config', QR_ACTIVATION_CONFIG_HBO_DEFAULT);
    await showModalActivaHBOMaxQR(qrActivationConfigHBO);
  }


  sendMetricsActivateHBO() {
    const ga4 = new GA4();
     const pagePath = window.location.pathname;
    const metrics = {
      page_path: pagePath.split('/')[0],
      page_title: pagePath.split('/')[1],
      page_url: window.location.href,
      interaction_type: 'Activar HBO',
      modulo_name: pagePath.split('/').filter(Boolean).join(', '),
    }

    ga4.sendMetricsActivateHBO(metrics);
  }

  render() {
     const p = {
      className: 'modal-social',
      buttonsAlign: 'vertical',
      buttons: this.state.buttons,
      children: this.props.children,
    };
    return <ModalWrapper {...p} />;
  }
}

export default withOnClose(ModalProfile);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalProfile.jsx